module.exports = __webpack_public_path__ + "static/img/08102903viac.d275152b.jpg";